import bigNumberCarousel from './bigNumberCarousel';
import textCarousel from './textCarousel';
import flat from './flat';
import expandable from './expandable';
import twoSided from './twoSided';
import catchMeUp from './catchMeUp';

export default {
    flat,
    expandable,
    number_carousel: bigNumberCarousel,
    text_carousel: textCarousel,
    two_sided: twoSided,
    catch_me_up: catchMeUp,
};
